export default "__VITE_ASSET__44HFYC1lYEHtBxYF7gnsUA__";